import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { deleteDoc, doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { useAuth } from "../auth/AuthGate";
import { db } from "../../firebase/firebase";

export default function WishlistButton({ item, workflow }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(false);
  const wishlistId = `${workflow}_${item.id}`;
  useEffect(() => {
    if (!user) { setSaved(false); return undefined; }
    return onSnapshot(doc(db, "customers", user.uid, "wishlist", wishlistId), (snapshot) => setSaved(snapshot.exists()));
  }, [user, wishlistId]);
  const toggle = async (event) => {
    event.preventDefault(); event.stopPropagation();
    if (!user) return;
    const reference = doc(db, "customers", user.uid, "wishlist", wishlistId);
    if (saved) await deleteDoc(reference);
    else await setDoc(reference, { itemId:item.id, workflow, categoryId:item.categoryId||"", sectionId:item.sectionId||"", garmentId:item.garmentId||"", name:item.name||item.serviceName||"Product", description:item.description||"", imageUrl:item.imageUrl||item.image||item.mainImage||"", price:Number(item.basePrice??item.price??item.fixedPrice??0), savedAt:serverTimestamp() });
  };
  return <button type="button" onClick={toggle} aria-label={saved?"Remove from wishlist":"Add to wishlist"} title={saved?"Remove from wishlist":"Add to wishlist"} className={`absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full border shadow-md transition ${saved?"border-[#F46524] bg-[#F46524] text-white":"border-white/80 bg-white/95 text-[#F46524] hover:bg-[#FFF0E7]"}`}><Heart size={20} fill={saved?"currentColor":"none"}/></button>;
}
